import { ENRICHMENT_CATEGORY_TYPE_CUSTOM, ENRICHMENT_CATEGORY_TYPE_PROFILE, ENRICHMENT_CATEGORY_TYPE_QUESTIONAIRE, ENRICHMENT_CATEGORY_TYPE_VOTE } from "common-data-handling";

export function getTargetURL(eventId, target) {
    // Copied from App.cs::OpenTargetScreen
    let parts = target.split('/'), screen = parts[0];
    switch (screen) {
        case 'enrich_profile':
            return ['/events', eventId, 'enrich', ENRICHMENT_CATEGORY_TYPE_PROFILE].join('/');
        case 'vote':
            return ['/events', eventId, 'enrich', ENRICHMENT_CATEGORY_TYPE_VOTE].join('/');
        case 'questionaire':
            return ['/events', eventId, 'enrich', ENRICHMENT_CATEGORY_TYPE_QUESTIONAIRE].join('/');
        case 'custom_enrich':
            return ['/events', eventId, 'enrich', ENRICHMENT_CATEGORY_TYPE_CUSTOM].join('/');
        case 'program':
            return ['/events', eventId, 'schedule'].join('/');
        case 'news':
            return ['/events', eventId, 'notifications'].join('/');
        case 'participants':
            return ['/events', eventId, 'participants'].join('/');
        case 'questions':
            return ['/events', eventId, 'qa'].join('/');
        case 'events':
            if (parts[1]) {
                return ['/events', parts[1]].join('/');
            } else {
                return ['/events', eventId, 'agenda'].join('/');
            }
    }
    return ['/events', eventId].join('/');
}
